import _ from 'lodash';
import React from 'react';
import TZDate from '../services/TZDate';
import SpecialOpeningHours from './SpecialOpeningHours';

class SpecialOpeningHoursContainer extends React.Component {
  constructor(props) {
    super(props);

    this.updateProp = this.updateProp.bind(this);
    this.updateStartAndEnd = this.updateStartAndEnd.bind(this);
    this.getSpecialIdx = this.getSpecialIdx.bind(this);
    this.getSpecial = this.getSpecial.bind(this);
  }

  updateStartAndEnd(start, end) {
    const { data, onUpdate } = this.props;
    const specialIdx = this.getSpecialIdx();
    const startDate = TZDate.createFromDateAndTimeString(start);
    const endDate = TZDate.createFromDateAndTimeString(end);

    if (endDate.isBefore(startDate)) {
      [start, end] = [end, start];
    }

    onUpdate(data, {
      specialOpeningHours: {
        [specialIdx]: {
          start: { $set: start },
          end: { $set: end }
        }
      }
    });
  }

  updateProp(prop, val, save, triggerSettingsUpdate) {
    const { data, onUpdate } = this.props;
    const specialIdx = this.getSpecialIdx();

    onUpdate(
      data,
      {
        specialOpeningHours: {
          [specialIdx]: { [prop]: { $set: val } }
        }
      },
      save,
      triggerSettingsUpdate
    );
  }

  getSpecialIdx() {
    const { data, id } = this.props;
    return _.findIndex(data.specialOpeningHours, special => special.id === id);
  }

  getSpecial() {
    const { data } = this.props;
    const specialIdx = this.getSpecialIdx();

    return data.specialOpeningHours[specialIdx];
  }

  render() {
    const { data, id, ...otherProps } = this.props;
    const special = this.getSpecial();

    return (
      <SpecialOpeningHours
        timeranges={special.openingHours}
        note={special.note}
        start={special.start}
        end={special.end}
        onTimerangesChange={newTimeranges => {
          this.updateProp('openingHours', newTimeranges);
        }}
        onTitleChange={newTitle => {
          this.updateProp('title', newTitle);
        }}
        onNoteChange={newNote => {
          this.updateProp('note', newNote, true, false);
        }}
        onStartChange={newStart => {
          this.updateStartAndEnd(newStart, special.end);
        }}
        onEndChange={newEnd => {
          this.updateStartAndEnd(special.start, newEnd);
        }}
        {...otherProps}
      />
    );
  }
}

export default SpecialOpeningHoursContainer;



// WEBPACK FOOTER //
// ./src/commons/components/SpecialOpeningHoursContainer.jsx